import React, {useState, useContext, useEffect} from 'react';
import { Table } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import Preloader from '../../components/Preloader/Preloader';
  import {Helmet} from 'react-helmet-async';

  const config = require('../../config.json');

const modernBooksStyles = `
  .mybooks-modern-card {
    background: linear-gradient(135deg, #f8fafc 60%, #e0e7ff 100%);
    border-radius: 18px;
    box-shadow: 0 4px 24px 0 rgba(80, 80, 120, 0.10);
    padding: 0.7rem 0.3rem 0.7rem 0.3rem;
    margin: 0 auto 1.2rem auto;
    max-width: 900px;
    position: relative;
    z-index: 1;
  }
  .mybooks-modern-header {
    text-align: center;
    font-weight: 700;
    font-size: 1.5rem;
    margin-bottom: 1.2rem;
    letter-spacing: 0.5px;
    color: #3b3b6d;
  }
  .mybooks-modern-msg {
    text-align: center;
    font-size: 1.08rem;
    color: #6366f1;
    margin-bottom: 1.2rem;
    font-weight: 500;
  }
  .mybooks-modern-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(99,102,241,0.07);
    margin-bottom: 0;
  }
  .mybooks-modern-table th, .mybooks-modern-table td {
    padding: 0.7rem 0.5rem;
    text-align: center;
    font-size: 1.01rem;
    border-bottom: 1px solid #e5e7eb;
  }
  .mybooks-modern-table th {
    background: #6366f1;
    color: #fff;
    font-weight: 600;
    border-bottom: 2px solid #6366f1;
    position: sticky;
    top: 0;
    z-index: 2;
  }
  .mybooks-modern-table tr:last-child td {
    border-bottom: none;
  }
  .mybooks-modern-table tbody tr:hover {
    background: #f1f5ff;
    transition: background 0.18s;
  }
  .mybooks-sort-icon {
    margin-left: 0.3em;
    color: #fff;
    cursor: pointer;
    font-size: 1em;
    vertical-align: middle;
    transition: color 0.18s;
  }
  .mybooks-sort-icon:hover {
    color: #ffe066;
  }
  @media (max-width: 900px) {
    .mybooks-modern-card {
      max-width: 99vw;
      padding: 0.4rem 0.05rem 0.4rem 0.05rem;
    }
    .mybooks-modern-header {
      font-size: 1.1rem;
    }
    .mybooks-modern-table th, .mybooks-modern-table td {
      font-size: 0.97rem;
      padding: 0.5rem 0.2rem;
    }
  }
  @media (max-width: 600px) {
    .mybooks-modern-card {
      padding: 0.1rem 0rem 0.1rem 0rem;
    }
    .mybooks-modern-header {
      font-size: 1rem;
    }
    .mybooks-modern-table th, .mybooks-modern-table td {
      font-size: 0.93rem;
      padding: 0.4rem 0.1rem;
    }
    .mybooks-modern-table {
      border-radius: 7px;
    }
  }
`;

export default function MyBooks() {
    const { validateLogin, loggedUser } = useContext(ProductContext);
    const { enqueueSnackbar } = useSnackbar();
    const [bookResult, setBookResult] = useState([]);
    //const [bookSelect, setBookSelect]= useState();
    const [loaded, setLoaded] = useState(true);
    const [issuedBooks, setIssuedBooks]=useState([]);
    //const [show, setShow] = useState(false);
    //const [modalTitle, setModalTitle] = useState('')
    //const ref = useRef([]);
    const [dispMsg, setDispMsg] = useState('');

    useEffect(()=>{
        if(!loggedUser.isAuthenticated){
          validateLogin();
        }else{
            handleUserSearch();
        }
      },[loggedUser])

      const handleUserSearch=async()=>{
        try{
              setLoaded(false);
              const { idToken } = (await fetchAuthSession()).tokens ?? {};
              const searchValue=loggedUser.phone_number.substring(3);;
              console.log("Logged user :", searchValue);
              //const searchTopic="UserID";
            /*await axios.get(`${config.userapi.invokeURL}/dashboard/student/search?fetchKey=${searchValue}&fetchOption=${searchTopic}`, {
              headers: {
                Authorization: idToken,
                'x-api-key':config.userapi.key
              }
            }).then(async(response) => {
             console.log("response : ", response.data);
              if(response.data.length>0)
              {
                  setUserResult(response.data);
              }
              enqueueSnackbar(response.data.length + " - student's records found!",{variant:'success'}); 
              setLoaded(true);
          }).catch((error)=>{
            enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
          setLoaded(true);
        })*/
        const clientID="AKLibrary";
        //console.log("search value :", searchValue);
        const tempTopic="UserID";
        await axios.get(`${config.api.invokeUrl}/issue?fetchKey=${searchValue}&fetchOption=${tempTopic}&clientID=${clientID}`, {
          headers: {
            Authorization: idToken,
           'x-api-key':config.api.key
          }
        }).then(async(response) => {
         //console.log("response : ", response);
         //setDispMsg(response.data.length+' - Books Found');
         const bookCount = response.data.length;

              setIssuedBooks(response.data);
          
          //console.log("response : ", bookCount);
          if(response.data.length<=0){
            setDispMsg("You have " + bookCount +" books assigned to your name. Start using our digital library and enrich your knowledge");
          }else if(response.data.length>=18){
            setDispMsg("You have " + bookCount +" books assigned to your name. You are close to the target of 20 books. Return unused books immediately.");
          }else {
            setDispMsg("You have " + bookCount +" books assigned to your name. Enjoy our digital library");
          }
          enqueueSnackbar(response.data.length+' - Books Found',{variant:'success'}); 
          setLoaded(true);
      }).catch((error)=>{
        enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
      setLoaded(true);
    })
          }catch(error){
            enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
          setLoaded(true);
          }
    }

    const handleSortKey =async(event, value)=>{
        event.preventDefault();
        console.log("clicked");
        if(value==="AccessionNo"){
          const tempOrginalValue=bookResult;
          setBookResult([]);
          //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
          var sortedOptionArray = tempOrginalValue.sort((a, b) => {return a.accessionNo - b.accessionNo;});
          console.log("Sorted AccessionNo Array ", sortedOptionArray);
          await setBookResult(sortedOptionArray);
        }else if(value==="BookTitle"){
          const tempOrginalValue=bookResult;
          //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
          var sortedOptionArray = tempOrginalValue.sort((a, b) => {return a.bookTitle - b.bookTitle;});
          console.log("Sorted Book Array ", sortedOptionArray);
          await setBookResult(sortedOptionArray);
        }else if(value==="BookingDate"){
          var tempOrginalValue=bookResult;
          //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
          var sortedOptionArray = tempOrginalValue.sort((a, b) => {return a.bookedOn - b.bookedOn;});
          tempOrginalValue.sort((a, b) => (a.name - b.name ? 1 : -1));
      
          console.log("Sorted Book Array ", tempOrginalValue);
          await setBookResult(sortedOptionArray);
        }
        
      }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(120deg, #f1f5ff 60%, #e0e7ff 100%)', padding: '0' }}>
      <Helmet>
        <title>My Books - Inigo Library - Arul Kadal - Chennai</title>
        <meta name="description" content="My Books - Inigo Library - Arul Kadal - Chennai" />
        <meta name="keywords" content="My Books - Inigo Library - Arul Kadal - Chennai" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <style>{modernBooksStyles}</style>
      {!loaded && <Preloader show={loaded ? false : true} />}
      <div className="mybooks-modern-card">
        <div className="mybooks-modern-header">My Books</div>
        <div className="mybooks-modern-msg">{dispMsg}</div>
        <div style={{overflowX: 'auto'}}>
          <table className="mybooks-modern-table">
            <thead>
              <tr>
                <th>#</th>
                <th>
                  Accession No
                  <i className="fa fa-sort mybooks-sort-icon" aria-hidden="true" onClick={event => handleSortKey(event, "AccessionNo")}></i>
                </th>
                <th>
                  Book Title
                  <i className="fa fa-sort mybooks-sort-icon" aria-hidden="true" onClick={event => handleSortKey(event, "BookTitle")}></i>
                </th>
                <th>
                  Author
                  <i className="fa fa-sort mybooks-sort-icon" aria-hidden="true" onClick={event => handleSortKey(event, "BookTitle")}></i>
                </th>
                <th>
                  Classification No
                  <i className="fa fa-sort mybooks-sort-icon" aria-hidden="true" onClick={event => handleSortKey(event, "BookTitle")}></i>
                </th>
                <th>
                  Booking Date
                  <i className="fa fa-sort mybooks-sort-icon" aria-hidden="true" onClick={event => handleSortKey(event, "BookingDate")}></i>
                </th>
                <th>
                  Return Date
                  <i className="fa fa-sort mybooks-sort-icon" aria-hidden="true" onClick={event => handleSortKey(event, "BookTitle")}></i>
                </th>
              </tr>
            </thead>
            <tbody>
              {issuedBooks.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.accessionNo}</td>
                  <td>{item.bookTitle}</td>
                  <td>{item.bookAuthor}</td>
                  <td>{item.bookClassificationNo}</td>
                  <td>{item.bookedOn}</td>
                  <td>{item.bookedTo}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
